"use client"
import { locale } from "@locale";
import classNames from 'classnames';
import { createPortal } from "react-dom";
import TrailerPlayer from 'src/components/film/TrailerPlayer';
import { useTrailerContext } from 'src/components/film/TrailerWrapper';
import CloseSvg from 'src/components/svg/CloseSvg';
import PlaySvg from 'src/components/svg/PlaySvg';
import type { ITrailer } from "src/lib/types/Trailer";
import styles from './TrailerContent.module.css';
import getThemeStyles from "src/lib/styling/getThemeStyles";
import OverlayPortal from "src/components/overlayportal/OverlayPortal";

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type TrailerContentProps = {
    trailer?: ITrailer;
    streamingTrailer?: string | null; // youtubeId
    className?: string;
    showText?: boolean;
    isStreamingContext?: boolean;
};
//#endregion

//#region [Component]
export default function TrailerContent({ trailer, streamingTrailer, className, showText = false, isStreamingContext }: TrailerContentProps) {
    const trailerContext = useTrailerContext();

    const hasTrailer = !((!isStreamingContext && !trailer) || (isStreamingContext && !trailer && !streamingTrailer));


    const themeStyles = getThemeStyles(styles, {[styles.isDisabled]: !hasTrailer});

    return <>
        <div className={classNames(styles.STrailerButton, className, themeStyles)} aria-hidden={!hasTrailer}>
            <button className={styles.SButton} onClick={() => trailerContext.setIsPlaying(true)} disabled={!hasTrailer} aria-label={locale.trailere.trailerButtonText}>
                <PlaySvg className={styles.SPlaySvg} />
                {showText && <span className={styles.SIconText}>{locale.trailere.trailerButtonText}</span>}
            </button>
        </div>
        {trailerContext.isPlaying && <OverlayPortal doClose={() => trailerContext.setIsPlaying(false)} className={classNames(themeStyles)}>
            <TrailerPlayer trailer={trailer} streamingTrailer={isStreamingContext ? streamingTrailer : undefined} />
        </OverlayPortal>}
        {/*trailerContext.isPlaying && createPortal(<div className={classNames(styles.SPlayerContainer, themeStyles)}>
            <button className={styles.SVideoCloseButton} onClick={() => trailerContext.setIsPlaying(false)}>
                <CloseSvg className={styles.SCloseSvg} />
            </button>
            <TrailerPlayer trailer={trailer} streamingTrailer={isStreamingContext ? streamingTrailer : undefined} />
        </div>, document.body, `trailerPortal_${trailer?._id ?? streamingTrailer}`)*/}
    </>;
}
//#endregion